import { ParamsLink } from 'components/Links';
import Dropdown from 'components/UIKit/Dropdown';

const severityLevels = [
  'CRITICAL',
  'WARNING',
];

const ErrorTypeFilter = ({
  severity,
  query,
  style,
}) => (
  <span style={style}>
    <span>Severity: &nbsp;</span>
    <Dropdown selected={severity || 'All'}>
      <ParamsLink
        query={{
          ...query,
          offset: 0,
        }}
        includeCurrentParams={false}
        >
        All
      </ParamsLink>
      {severityLevels
        .map(level => (
          <ParamsLink
            active={level === severity}
            key={level}
            query={{
              ...query,
              severity: level,
              offset: 0,
            }}
            includeCurrentParams={false}
            >
            {level}
          </ParamsLink>
        ))
      }
    </Dropdown>
  </span>
);

export default ErrorTypeFilter;
